import React from 'react'

import { Box, Grid, Icon } from '@factorialco/deprecated-design-system'
import { AnimatePresence, motion } from 'framer-motion'
import { AvailableModules } from 'generated/featureDefinitions'
import { ItemModuleFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useCheckModuleAcquired } from 'modules/marketplace_modules/hooks/useCheckModuleAcquired'
import UpsellTrialBanner from 'modules/upsell/components/UpsellTrialBanner'

import Carousel from '../Carousel'
import Contact from '../Contact'
import SharingArea from '../SharingArea'
import StepByStepDescription from '../StepByStepDescription'

type ContentType = {
  module: ItemModuleFragment
}

export default function Content({ module }: ContentType) {
  const { company } = useCurrentSession()
  const { inFreeTrial } = company.subscription
  const isAcquired = useCheckModuleAcquired(module.chargebeeModuleName!)
  const videoUrl = `https://www.youtube.com/embed/${
    module?.externalUrl?.split('v=')[1]?.split('&')[0]
  }`
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  }

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0 },
  }

  const images = module?.images?.map((image) => image.url)

  const carouselImages = images?.map((item) => {
    const imgObj = {
      url: item,
      alt: '',
    }
    return imgObj
  })

  const getMedia = () => {
    if (module?.externalUrl) {
      return (
        <Box
          padding="s32"
          width="full"
          background="grey100"
          borderRadius={{
            all: 'abs016',
          }}
          border={{ all: { width: 's1', style: 'solid', color: 'grey400' } }}
          style={{ marginTop: '32px' }}
        >
          <iframe
            height="100%"
            width="100%"
            src={videoUrl}
            allowFullScreen
            style={{
              maxWidth: '898px',
              height: '505px',
              overflow: 'hidden',
              borderRadius: '16px',
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'center',
            }}
          />
        </Box>
      )
    } else if (carouselImages) {
      return <Carousel media={carouselImages} />
    }
  }

  return (
    <AnimatePresence>
      <motion.div layout variants={container} initial="hidden" animate="show">
        <Box paddingTop="s12" paddingBottom="s48" paddingX="s48" width="full" gap="s32">
          {!inFreeTrial && <UpsellTrialBanner module={module} />}
          <Box>
            <motion.div variants={item}>
              <Contact
                data={{
                  icon: module.icon as React.ComponentProps<typeof Icon.Large>['icon'],
                  title: module.translatedName!,
                  description: module.shortDescription!,
                  chargebeeModuleId: module.chargebeeModuleId!,
                  chargebeeModuleName: module.chargebeeModuleName! as AvailableModules,
                }}
                moduleId={module.slug}
                isAcquired={isAcquired}
              />
            </motion.div>
            <motion.div variants={item}>{getMedia()}</motion.div>

            <motion.div variants={item}>
              <Box width="full" paddingTop="s48">
                <Grid variant="fixed">
                  <Box width="full" gridColSpan={{ xxs: 12, s: 7, m: 8 }}>
                    <Box>
                      <StepByStepDescription
                        stepByStepDescription={module.description!}
                        id={module.id!}
                      />
                    </Box>
                  </Box>

                  <Box gap="s24" gridColSpan={{ xxs: 12, s: 5, m: 4 }}>
                    <SharingArea moduleTitle={module.name!} moduleUrl={window?.location?.href} />
                  </Box>
                </Grid>
              </Box>
            </motion.div>
          </Box>
        </Box>
      </motion.div>
    </AnimatePresence>
  )
}
